import routes from '../../../route_names'
import { getDefaultInterval } from '@/helpers/filter'

export default {
  path: 'accounts',
  name: routes.ACCOUNTS,
  component: () =>
    import(/* webpackChunkName: "dashboard" */ './AccountsView.vue'),
  meta: {
    layout: 'dashboard/DashboardLayout',
    requiresAuth: true,
    requiredRole: 'ADMIN',
    defaultChild: routes.ACCOUNTS_PROFILE_VIEW
  },
  children: [
    {
      path: 'profile',
      name: routes.ACCOUNTS_PROFILE_VIEW,
      component: () =>
        import(/* webpackChunkName: "dashboard" */ './profile/ProfileView.vue'),
      meta: {
        layout: 'dashboard/DashboardLayout',
        requiresAuth: true,
        requiredRole: 'ADMIN',
        requireDateFilter: true,
        defaultChild: routes.ACCOUNTS_PROFILE_DETAILS
      },
      children: [
        {
          path: 'details',
          name: routes.ACCOUNTS_PROFILE_DETAILS,
          component: () =>
            import(
              /* webpackChunkName: "dashboard" */ './profile/Details.vue'
            ),
          meta: {
            layout: 'dashboard/DashboardLayout',
            requiresAuth: true,
            requiredRole: 'ADMIN',
            requireDateFilter: true
          }
        },
        {
          path: 'change-password',
          name: routes.ACCOUNTS_PROFILE_CHANGE_PASSWORD,
          component: () =>
            import(
              /* webpackChunkName: "dashboard" */ './profile/ChangePassword.vue'
            ),
          meta: {
            layout: 'dashboard/DashboardLayout',
            requiresAuth: true,
            requiredRole: 'ADMIN',
            requireDateFilter: true
          }
        }
      ]
    },
    {
      path: 'team',
      name: routes.ACCOUNTS_TEAM,
      component: () =>
        import(/* webpackChunkName: "dashboard" */ './TeamView.vue'),
      meta: {
        layout: 'dashboard/DashboardLayout',
        requiresAuth: true,
        requiredRole: 'ADMIN',
        requireDateFilter: true
      }
    },
    {
      path: 'billing',
      name: routes.ACCOUNTS_BILLING,
      component: () =>
        import(/* webpackChunkName: "dashboard" */ './billing/BillingView.vue'),
      meta: {
        layout: 'dashboard/DashboardLayout',
        requiresAuth: true,
        requiredRole: 'ADMIN',
        requireDateFilter: true,
        defaultChild: routes.ACCOUNTS_BILLING_CURRENT
      },
      children: [
        {
          path: 'current-plan',
          name: routes.ACCOUNTS_BILLING_CURRENT,
          component: () =>
            import(
              /* webpackChunkName: "dashboard" */ './billing/CurrentPlan.vue'
            ),
          meta: {
            layout: 'dashboard/DashboardLayout',
            requiresAuth: true,
            requiredRole: 'ADMIN',
            requireDateFilter: true
          }
        },
        {
          path: 'plans',
          name: routes.ACCOUNTS_BILLING_PLANS,
          component: () =>
            import(
              /* webpackChunkName: "dashboard" */ './billing/Plans.vue'
            ),
          meta: {
            layout: 'dashboard/DashboardLayout',
            requiresAuth: true,
            requiredRole: 'ADMIN',
            requireDateFilter: true
          }
        },
        {
          path: 'history',
          name: routes.ACCOUNTS_BILLING_INVOICES,
          component: () =>
            import(
              /* webpackChunkName: "dashboard" */ './billing/Invoices.vue'
            ),
          meta: {
            layout: 'dashboard/DashboardLayout',
            requiresAuth: true,
            requiredRole: 'ADMIN',
            requireDateFilter: true
          }
        }
      ]
    },
    {
      path: 'stats',
      name: routes.ACCOUNTS_STATS,
      component: () =>
        import(
          /* webpackChunkName: "dashboard" */ './Stats.vue'
        ),
      meta: {
        layout: 'dashboard/DashboardLayout',
        requiresAuth: true,
        requiredRole: 'ADMIN',
        requireDateFilter: true
      }
    },
    {
      path: 'business-category',
      name: routes.ACCOUNTS_BUSINESS_CATEGORY,
      component: () =>
        import(/* webpackChunkName: "dashboard" */ './BusinessCategoryView.vue'),
      meta: {
        layout: 'dashboard/DashboardLayout',
        requiresAuth: true,
        requiredRole: 'ADMIN',
        requireDateFilter: true
      }
    }
  ]
}
